/**
 * Firmenweite Parameter der Satzberechnung (NP20-933).
 *
 * Die Werte liegen zentral im Backend, damit alle Anwender denselben Stand
 * sehen; berechnete Groessen werden nicht persistiert.
 */
export interface CostCalculationSettings {
  marginEuro: number;
  adminOverheadEuro: number;
  travelExpenseHourly: number;
}

/** Fallback, solange das Backend keine Werte liefert (Ladefehler). */
export const DEFAULT_COST_CALCULATION_SETTINGS: CostCalculationSettings = {
  marginEuro: 10,
  adminOverheadEuro: 15,
  travelExpenseHourly: 11,
};
